<template>
  <div class="modal fade" id="modalFeedback" role="dialog">
    <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
      <!-- Modal content-->
      <div class="modal-content modal-feedback">
        <div class="modal-body">
          <div class="content-title">
            <h5 v-if="isCreate" class="modal-title modal-title1"><span class="certa">Novo Feedback</span></h5>
            <h5 v-if="isDetail" class="modal-title modal-title1"><span class="certa">Detalhes do Feedback</span></h5>
            <h5 v-if="isSolicitation || isRequested" class="modal-title modal-title1"><span class="certa">Solicitação de Feedback</span></h5>
            <p v-if="isCreate && stepSelectUser || isSolicitation" class="sub-title">
              <span v-if="dataModal.modalType === 3">Selecione para quem deseja solicitar o Feedback:</span>
              <span v-else>Selecione para quem deseja enviar o Feedback:</span>
            </p>
            <p v-if="(isDetail || isRequested) && !loading" class="sub-title">Enviado em {{dataValue.createdAt | formatDateHours}}</p>
            <p v-if="dataValue.readAt && !isCreate && !isRequested" class="read-at"><span>Visualizado em: <span>{{dataValue.readAt | formatDateHoursSeconds}}</span></span></p>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>

          <div v-if="loading">
            <progress-loading :additionalBoxStyle="'margin-top: 20px; min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
            <progress-loading :additionalBoxStyle="'min-height: 45px;'" :additionalLineStyle="'height: 20px'"/>
          </div>

          <div v-if="stepConfirmAction && isRequested && !loading">

              <h6>Solicitado por</h6>
              <div class="content-photo-and-infos offset-top-20">
                <div class="photo">
                  <p v-if="!dataValue.fromUserPhotoUri">{{dataValue.fromUserName | formatName}}</p>
                  <img v-bind:src="dataValue.fromUserPhotoUri" v-if="dataValue.fromUserPhotoUri" alt="Foto" />
                </div>
                <a class="no-link">{{dataValue.fromUserName}}</a>
                <p class="office">{{dataValue.fromUserOffice}}</p>
              </div>
              <div class="line-modal m-top-0"></div>
              <p class="motive-txt">Motivo: <strong>{{ dataValue.requestedReason  || '-'}}</strong></p>

              <div class="double-btns-action">
                <button v-on:click="cancelSolicitation()" :disabled="loadingCancel" v-bind:class="{'disable': loadingCancel}" type="button" class="nunito">
                  <span v-if="!loadingCancel">Recusar solicitação</span>
                  <div class="loading-btn" v-else>
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
                <button v-on:click="stepConfirmAction = false;" :disabled="loadingCancel" v-bind:class="{'disable': loadingCancel}" type="button" class="nunito">
                  <span>Enviar feedback</span>
                </button>
              </div>

          </div>

          <div v-if="(isCreate && stepSelectUser) && !loading || (isSolicitation && stepSelectUser) && !loading">
            <div class="form-group offset-top-20">
              <p>Pesquisar por nome  <i v-tooltip.top-center="'Mostrando apenas as pessoas que você possui permissão para enviar Feedback.'" class="fa fa-info-circle info-view" aria-hidden="true"></i></p>
              <input v-model="nameSearch" type="text" class="form-control" name="search" placeholder="Comece digitando o nome">
              <ion-icon name="search-outline"></ion-icon>
            </div>

            <div class="box-select-user custom-scrollbar">
              <div v-on:click="setUser(v)" v-for="v in filteredUsers" v-bind:class="{'selected-box': userSelected.id === v.id}" class="list-users">
                <div class="custom-radio">
                  <i class="fa fa-check"></i>
                </div>
                <div class="data-user">
                  <div class="content-photo-and-infos">
                    <div class="photo">
                      <p v-if="!v.photo">{{v.name | formatName}}</p>
                      <img v-bind:src="v.photo" v-if="v.photo" alt="Foto" />
                    </div>
                    <a class="no-link">{{v.name}}</a>
                    <p class="office">{{v.officeName}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="double-btn">
              <button v-on:click="closeModal()" type="button" class="nunito close-btn">Fechar</button>
              <button v-on:click="stepSelectUser = false" type="submit" :disabled="!userSelected.id" v-bind:class="{'disable': !userSelected.id}" class="nunito">
                <span>Próximo</span>
              </button>
            </div>
          </div>

          <div v-if="isSolicitation && !stepSelectUser && !loading" class="is-solicitation">
            <h6>Funcionário selecionado</h6>
            <div class="content-photo-and-infos offset-top-20">
              <div class="photo">
                <p v-if="!userSelected.photo">{{userSelected.name | formatName}}</p>
                <img v-bind:src="userSelected.photo" v-if="userSelected.photo" alt="Foto" />
              </div>
              <a class="no-link">{{userSelected.name}}</a>
              <p class="office">{{userSelected.officeName}}</p>
            </div>
            <div class="line-modal"></div>
            <h6>Motivo da solicitação</h6>

            <div class="content-solicitation">
              <label>Motivo <span>*</span></label>
              <textarea v-model="description" maxlength="244" placeholder="Digite aqui"></textarea>
            </div>

            <div class="double-btn">
              <button v-on:click="closeModal()" type="button" class="nunito close-btn">Fechar</button>
              <button v-on:click="sendSolicitation()" type="submit" class="nunito">
                <span v-if="!loadingSolicitation">Enviar Solicitação</span>
                <div class="loading-btn" v-else>
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </button>
            </div>
          </div>

          <form v-if="!loadingData && !stepSelectUser && !isSolicitation && !loading && !stepConfirmAction" name="formModal" novalidate class="formModal text-left offset-top-20">
            <div v-if="isCreate">
              <h6>Funcionário selecionado</h6>
              <div class="content-photo-and-infos offset-top-20">
                <div class="photo">
                  <p v-if="!userSelected.photo">{{userSelected.name | formatName}}</p>
                  <img v-bind:src="userSelected.photo" v-if="userSelected.photo" alt="Foto" />
                </div>
                <a class="no-link">{{userSelected.name}}</a>
                <p class="office">{{userSelected.officeName}}</p>
              </div>
              <div class="line-modal"></div>
            </div>

            <div v-show="isDetail || isRequested">
              <h6 v-if="typeSearchModal === 'received'">De</h6>
              <h6 v-else>{{isRequested ? 'Solicitado por' : 'Para'}}</h6>

              <div v-if="typeSearchModal === 'received' || isRequested" class="content-photo-and-infos">
                <div class="photo">
                  <p v-if="!dataValue.fromUserPhotoUri">{{dataValue.fromUserName | formatName}}</p>
                  <img v-bind:src="dataValue.fromUserPhotoUri" v-if="dataValue.fromUserPhotoUri" alt="Foto" />
                </div>
                <a class="no-link" v-bind:class="{'anonymous': !dataValue.fromUserOffice}">{{dataValue.fromUserName}}</a>
                <p v-if="dataValue.fromUserOffice" class="office">{{dataValue.fromUserOffice}}</p>
              </div>
              <div v-else class="content-photo-and-infos">
                <div class="photo">
                  <p v-if="!dataValue.toUserPhotoUri">{{dataValue.toUserName | formatName}}</p>
                  <img v-bind:src="dataValue.toUserPhotoUri" v-if="dataValue.toUserPhotoUri" alt="Foto" />
                </div>
                <a class="no-link">{{dataValue.toUserName}}</a>
                <p v-if="dataValue.toUserOffice" class="office">{{dataValue.toUserOffice}}</p>
              </div>
              <div class="line-modal"></div>
            </div>

            <div v-if="isDetail">
              <h6>Descrição</h6>

              <div v-if="textHtml" class="box-description">
                <p v-html="textHtml"></p>
              </div>
            </div>

            <div v-if="!isDetail">
              <div v-if="!userSelected" class="line-modal"></div>

              <h6>Descreva seu Feedback</h6>

              <div v-if="isCreate">
                <div class="select-input">
                  <label>Usar um modelo</label>
                  <select v-model="modelSelected">
                    <option v-for="t in listModels" :value="t" :key="t.id">{{ t.name }}</option>
                  </select>
                </div>
              </div>

              <div class="content-ckeditor">
                <vue-editor id="editor" v-model="dataSend.text" :editorToolbar="customToolbar"/>
              </div>
              <div v-if="invalidHtmlEditor">
                <span class="required-alert-msg">Campo obrigatório!</span>
              </div>

              <div class="line-modal"></div>

              <h6>Avalie as competências abaixo</h6>
            </div>

            <div v-bind:id="'box-competence' + index" v-for="(v, index) in listCompetence" class="box-competence" v-bind:class="{'border-default': isDetail, 'actived-card': v.rating >= 1}">
              <p class="name">{{v.title}} <i v-tooltip.top-center="v.description" class="fa fa-info-circle info-view" aria-hidden="true"></i></p>
              <div class="line-modal"></div>

              <div class="text-star">
                <small>Nota:</small>
              </div>
              <div class="star-rating">
                <ion-icon v-bind:id="'star5' + index" name="star" v-on:click="changeRating(index, 5)"></ion-icon>
                <ion-icon v-bind:id="'star4' + index" name="star" v-on:click="changeRating(index, 4)"></ion-icon>
                <ion-icon v-bind:id="'star3' + index" name="star" v-on:click="changeRating(index, 3)"></ion-icon>
                <ion-icon v-bind:id="'star2' + index" name="star" v-on:click="changeRating(index, 2)"></ion-icon>
                <ion-icon v-bind:id="'star1' + index" name="star" v-on:click="changeRating(index, 1)"></ion-icon>
              </div>
              <div v-if="isDetail" class="block-stars"></div>
            </div>
            <small v-if="!isDetail" class="small-info">Competências não avaliadas não ficarão visíveis para o avaliado</small>


            <div v-if="!isDetail" class="content-checkbox">
              <div v-if="canSendAnonymousFeedback" class="checkbox">
                <input id="check1" type="checkbox" v-model="dataSend.isAnonymous">
                <label for="check1"><span>Enviar como anônimo <i v-tooltip.top-center="'A pessoa não saberá quem enviou o feedback.'" class="fa fa-info-circle info-view" aria-hidden="true"></i></span></label>
                <div v-if="canSendAnonymousFeedback === false" class="block-content"></div>
              </div>

              <div class="checkbox">
                <input id="check2" type="checkbox" v-model="dataSend.receiveNotifyWhenViewed">
                <label for="check2"><span>Ser notificado quando o feedback for visualizado </span></label>
<!--                <div class="block-content"></div>-->
              </div>
            </div>

            <div class="double-btn">
              <button v-if="!isDetail" v-on:click="closeModal()" type="button" class="nunito close-btn">Fechar</button>
              <button v-if="isCreate || isRequested" v-on:click="checkDataCreate()" :disabled="loadingCreate" v-bind:class="{'disable': loadingCreate}" type="button" class="nunito">
                <span v-if="!loadingCreate">Enviar feedback</span>
                <div class="loading-btn" v-else>
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </button>
            </div>
<!--            <div class="double-btn-right">-->
<!--              <btn-loading v-if="isSolicitation" v-on:click="checkDataSolicitation(formModal)" btn-text="'Enviar feedback'" btn-class="'default-primary-btn'" loading-btn='loadingSend'></btn-loading>-->
<!--            </div>-->
            <div v-if="isDetail" class="btn-full">
              <button v-on:click="closeModal()" type="button" class="nunito close-btn">Fechar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Autocomplete from "vue2-autocomplete-js";
  import {
    CANCEL_FEEDBACK,
    CREATE_FEEDBACK,
    GET_COMPETENCE_FEEDBACK,
    GET_DETAIL_FEEDBACK,
    GET_EMPLOYEE_FEEDBACK, REQUEST_FEEDBACK,
    SEARCH_EMPLY
  } from "../../../urlConfig";
  import { VueEditor, Quill } from "vue2-editor";
  import {REQUEST_SERVICE} from "../../../requestConfig";
  import {UTIL_SERVICE} from "../../../utils";
  import swal from "sweetalert";
  import progressLoading from "../components/progressLoading";

  export default {
    name: "modal-feedback",
    components: {
      Autocomplete,
      progressLoading,
      VueEditor,
      Quill
    },
    props: ['dataModal'],
    watch: {
      dataModal: function (val) {
        this.dataSend = {
          companyId: UTIL_SERVICE.getStorage('userInfo').companyId,
          fromUserId: UTIL_SERVICE.getStorage('userInfo').id,
          text: '',
          toUserId: '',
          competences: [],
          isAnonymous: false,
          receiveNotifyWhenViewed: false,
        };
        this.textHtml = '';
        this.description = '';
        this.nameSearch = '';
        this.userSelected = {};

        this.loadingSolicitation = false;
        this.loadingCreate = false;
        this.isCreate = false;
        this.isSolicitation = false;
        this.isDetail = false;
        this.stepSelectUser = false;
        this.loading = false;
        this.isRequested = false;
        this.stepConfirmAction = false;
        this.dataUsers = [];

          this.typeSearchModal = val.typeSearch;
        switch (val.modalType) {
          case 1:
            this.isCreate = true;
            this.stepSelectUser = true;
            this.listCompetence = [];
            this.getListCompetence();
            this.getListEmployee(GET_EMPLOYEE_FEEDBACK);
            break;
          case 2:
            this.isDetail = true;
            this.listCompetence = [];
            this.getDetailFeedback(val.data.id);
            break;
          case 3:
            this.isSolicitation = true;
            this.stepSelectUser = true;
            this.getListEmployee(GET_EMPLOYEE_FEEDBACK + '?isRequest=true');
            break;
          case 4:
            this.listCompetence = [];
            this.isRequested = true;
            this.stepConfirmAction = true;
            this.getDetailFeedback(val.data.id);
            break;
        }
      },
      emitValue : function(val){
        this.$emit('update:dataPage', val)
      },
      modelSelected: function(newVal, oldVal) {
        if (newVal.id >= 0) {
          this.dataSend.text = newVal.description;
        }
      }
    },
    data() {
      return {
        modelSelected: {name: 'Selecione', id: 0, description: ''},
        listModels: [],
        typeSearchModal: '',
        description: '',
        dataSend: {
          companyId: UTIL_SERVICE.getStorage('userInfo').companyId,
          fromUserId: UTIL_SERVICE.getStorage('userInfo').id,
          text: '',
          toUserId: '',
          competences: [],
          isAnonymous: false,
          receiveNotifyWhenViewed: false,
        },
        customToolbar: [
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }]
        ],
        nameSearch: '',
        width: '700px',
        urlSearchEmp: SEARCH_EMPLY,
        bearerAutoComplete: JSON.parse(window.localStorage.getItem('authUser')).userToken,
        contentSetting: JSON.parse(window.localStorage.getItem('authUser')).userContentSetting,
        loadingData: false,
        stepConfirmAction: false,
        isRequested: false,
        acptyFeedback: false,
        isCreate: false,
        isSolicitation: false,
        isDetail: false,
        stepSelectUser: false,
        canSendAnonymousFeedback: false,
        invalidHtmlEditor: false,
        loadingCreate: false,
        loading: false,
        loadingCancel: false,
        loadingSolicitation: false,
        dataUsers: [],
        listCompetence: [],
        userSelected: {},
        dataValue: {},
        textHtml: '',
        emitValue: '',
      }
    },
    methods: {
      cancelSolicitation() {
        if (!this.loadingCancel) {
          this.loadingCancel = true;
          REQUEST_SERVICE.get(CANCEL_FEEDBACK +  this.dataValue.id).then((response) => {
            UTIL_SERVICE.console("RESULT REQUEST_FEEDBACK:", response.data);

            swal("Aviso", 'Feedback cancelado com sucesso.', "success");
            this.emitValue = {reloadPg: true, type: 'requested', random: Math.floor(Math.random() * 500)};
            this.loadingCancel = false;
            this.closeModal();
          }).catch(reason => {
            this.closeModal();
            this.loadingCancel = false;
            this.failRequest = true;
          })
        }
      },
      getDetailFeedback(id) {
        this.loading = true;
        REQUEST_SERVICE.get(GET_DETAIL_FEEDBACK + id).then((response) => {
          UTIL_SERVICE.console("RESULT GET_DETAIL_FEEDBACK:", response.data);

          this.dataValue = response.data;
          this.textHtml = response.data.text;
          this.listCompetence = response.data.competences;

          if (!this.isRequested) {
            setTimeout(() => {
              this.listCompetence.map((value, i) => {
                this.setColorStar(i, value.rating);
              });
            }, 200);
          }

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          this.failRequest = true;
        })
      },
      getListEmployee(url) {
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_EMPLOYEE_FEEDBACK:", response.data);

          this.dataUsers = response.data.users;

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          this.failRequest = true;
        })
      },
      getListCompetence() {
        this.loading = true;
        REQUEST_SERVICE.get(GET_COMPETENCE_FEEDBACK).then((response) => {
          UTIL_SERVICE.console("RESULT GET_COMPETENCE_FEEDBACK:", response.data);

          this.listCompetence = response.data.competences;
          this.canSendAnonymousFeedback = response.data.canSendAnonymousFeedback;

          response.data.competences.map((item, i) => {
            document.getElementById(`star1${i}`).classList.remove("actived-rating");
            document.getElementById(`star2${i}`).classList.remove("actived-rating");
            document.getElementById(`star3${i}`).classList.remove("actived-rating");
            document.getElementById(`star4${i}`).classList.remove("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
          });

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          this.failRequest = true;
        })
      },
      setUser(user) {
        this.userSelected = user;
      },
      setColorStar(i, value) {
        document.getElementById(`box-competence${i}`).classList.add('actived-card');
        switch (value) {
          case 1:
            document.getElementById(`star1${i}`).classList.add("actived-rating");
            document.getElementById(`star2${i}`).classList.remove("actived-rating");
            document.getElementById(`star3${i}`).classList.remove("actived-rating");
            document.getElementById(`star4${i}`).classList.remove("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
            break;
          case 2:
            document.getElementById(`star2${i}`).classList.add("actived-rating");
            document.getElementById(`star1${i}`).classList.add("actived-rating");
            document.getElementById(`star3${i}`).classList.remove("actived-rating");
            document.getElementById(`star4${i}`).classList.remove("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
            break;
          case 3:
            document.getElementById(`star3${i}`).classList.add("actived-rating");
            document.getElementById(`star2${i}`).classList.add("actived-rating");
            document.getElementById(`star1${i}`).classList.add("actived-rating");
            document.getElementById(`star4${i}`).classList.remove("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
            break;
          case 4:
            document.getElementById(`star4${i}`).classList.add("actived-rating");
            document.getElementById(`star3${i}`).classList.add("actived-rating");
            document.getElementById(`star2${i}`).classList.add("actived-rating");
            document.getElementById(`star1${i}`).classList.add("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
            break;
          case 5:
            document.getElementById(`star5${i}`).classList.add("actived-rating");
            document.getElementById(`star4${i}`).classList.add("actived-rating");
            document.getElementById(`star3${i}`).classList.add("actived-rating");
            document.getElementById(`star2${i}`).classList.add("actived-rating");
            document.getElementById(`star1${i}`).classList.add("actived-rating");
            break;
          default:
            document.getElementById(`box-competence${i}`).classList.remove('actived-card');
            document.getElementById(`star1${i}`).classList.remove("actived-rating");
            document.getElementById(`star2${i}`).classList.remove("actived-rating");
            document.getElementById(`star3${i}`).classList.remove("actived-rating");
            document.getElementById(`star4${i}`).classList.remove("actived-rating");
            document.getElementById(`star5${i}`).classList.remove("actived-rating");
            break;
        }
      },
      changeRating(i, value) {
        if (!this.isDetail) {
          if (this.listCompetence[i].rating !== value) {
            this.listCompetence[i].rating = value;
          } else {
            this.listCompetence[i].rating = 0;
            value = 0;
          }

          this.setColorStar(i, value);
        }
      },
      confirmAlert() {
        this.emitValue = {value: this.dataAlert.emit, random: Math.floor(Math.random() * 500)};

        $('#modalFeedback').modal('toggle');
        $('.modal-backdrop').remove();
      },
      sendSolicitation() {
        if (!this.loadingSolicitation) {
          this.loadingSolicitation = true;
          const objectSend = {
            message: this.description,
            toUserId: this.userSelected.id
          };

          UTIL_SERVICE.console("Data send:", objectSend);
          REQUEST_SERVICE.post(REQUEST_FEEDBACK, objectSend).then((response) => {
            UTIL_SERVICE.console("RESULT REQUEST_FEEDBACK:", response.data);

            swal("Aviso", 'Feedback solicitado com sucesso.', "success");
            this.emitValue = {reloadPg: true, type: 'requested', random: Math.floor(Math.random() * 500)};
            this.loadingCreate = false;
            this.closeModal();
          }).catch(reason => {
            this.loadingCreate = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
            this.closeModal();
          })
        }
      },
      closeModal() {
        $('#modalFeedback').modal('toggle');
        $('.modal-backdrop').remove();
      },
      checkDataCreate() {
        this.invalidHtmlEditor = false;
        if (this.dataSend.text) {
          if (!this.loadingCreate) {
            this.loadingCreate = true;
            this.dataSend.toUserId = this.userSelected.id;
            this.dataSend.competences = [];
            this.listCompetence.map((item) => {
              if (item.rating) {
                this.dataSend.competences.push(item);
              }
            });

            if (this.isRequested) {
              this.dataSend.id = this.dataValue.id;
              this.dataSend.toUserId = this.dataValue.fromUserId;
            }

            UTIL_SERVICE.console("Data send:", this.dataSend);
            REQUEST_SERVICE.post(CREATE_FEEDBACK, this.dataSend).then((response) => {
              UTIL_SERVICE.console("RESULT CREATE_FEEDBACK:", response.data);

              swal("Aviso", 'Feedback enviado com sucesso.', "success");
              this.emitValue = {reloadPg: true, type: 'sent', random: Math.floor(Math.random() * 500)};
              this.loadingCreate = false;
              this.closeModal();
            }).catch(reason => {
              this.loadingCreate = false;
              reason.response.data.erros.map((value, index) => {
                swal("Aviso", value.value, "error");
              });
              this.closeModal();
            })
          }
        } else {
          this.invalidHtmlEditor = true;
        }
      }
    },
    computed: {
      filteredUsers() {
        return this.dataUsers.filter(p => {
          // return true if the product should be visible

          // in this example we just check if the search string
          // is a substring of the product name (case insensitive)
          return p.name.toLowerCase().indexOf(this.nameSearch.toLowerCase()) !== -1;
        });
      }
    },
    beforeMount() {
      const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
      homeCtrl.advicesNeedReload = true;
      UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);

      this.listModels.push({name: 'Selecione', id: 0, description: ''});
      this.listModels.push({name: 'Não fazer mais / Continuar fazendo / Começar a fazer', id: 1, description: '<p><span style=\\"color: rgb(0, 0, 0);\\">Não fazer mais:</span></p><p><span style=\\"color: rgb(0, 0, 0);\\">(descreva o que seu colega faz e você entende que ele deva parar de fazer)</span></p><p><br></p><p><span style=\\"color: rgb(0, 0, 0);\\">Você deve continuar fazendo:</span></p><p><span style=\\"color: rgb(0, 0, 0);\\">(descreva a sugestão que o seu colega faz bem e deve continuar fazendo)</span></p><p><br></p><p><span style=\\"color: rgb(0, 0, 0);\\">Você deve começar a fazer:</span></p><p><span style=\\"color: rgb(0, 0, 0);\\">(descreva algo que seu colega ainda não faz mas você entende que ele deva começar a fazer)</span></p>'});
      this.listModels.push({name: 'Situação/Ação/Consequência', id: 2, description: '<p><span style=\\"color: rgb(0, 0, 0);\\">Descreva um problema ou situação em que a pessoa estava envolvida ou acabou deixando acontecer sem envolvimento e isso gerou alguma consequência relevante.</span></p><p><span style=\\"color: rgb(0, 0, 0);\\">Explique, justificando, se o comportamento da pessoa foi negativo ou positivo.</span></p>'});
      // this.listModels.push({name: '1 on 1', id: 3, description: '<p><span style=\\"color: rgb(0, 0, 0);\\">Descreva um problema ou situação em que a pessoa estava envolvida ou acabou deixando acontecer sem envolvimento e isso gerou alguma consequência relevante.</span></p><p><br></p><p><span style=\\"color: rgb(0, 0, 0);\\">Explique, justificando, se o comportamento da pessoa foi negativo ou positivo.</span></p>'});
      this.listModels.push({name: 'Positivo', id: 4, description: '<p><span style=\\"color: rgb(0, 0, 0);\\">Pontue um item em que você acredita que a pessoa agiu de maneira satisfatória e, se possível, faça um elogio para elevar sua moral.</span></p>'});
      this.listModels.push({name: 'Negativo', id: 5, description: '<p><span style=\\"color: rgb(0, 0, 0);\\">Pontue um item em que você acredita que a pessoa agiu de maneira não satisfatória e, se possível, deixe uma sugestão de como ela poderia ter feito melhor.</span></p>'});
    }
  }
</script>

<style lang="scss">
.anonymous {
  position: relative;
  top: 10px;
}

.m-top-0 {
  margin-top: 10px !important;
}

.motive-txt {
  font-family: 'Montserrat', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--titleBox) !important;
}

.select-input {
  width: 100%;
  margin-bottom: 30px;

  label {
    display: block;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #7F8897;
  }

  select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    background-color: #fff;
    border: 1px solid #c2cad8;
    border-radius: 4px;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalFeedback.vue